import { motion } from "framer-motion";
import { IMG, BUSINESS_TYPES } from "@/config";
import { SectionHeading } from "@/components/Section";
import { Reveal, stagger, fadeUp } from "@/components/Reveal";

export default function Businesses() {
  return (
    <section data-testid="businesses-serve" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] bg-sage -rotate-2" />
              <img
                src={IMG.chef}
                alt="Chef cooking in a busy commercial restaurant kitchen"
                className="relative rounded-[1.75rem] object-cover w-full h-[420px] md:h-[520px] border border-forest/15"
              />
              <div className="absolute -bottom-6 -right-2 md:right-6 bg-forest text-cream rounded-2xl px-6 py-5 shadow-hard-lg border border-forest">
                <p className="font-display text-3xl text-butter-deep">Hundreds</p>
                <p className="text-xs text-cream/70 mt-1 max-w-[10rem]">of food businesses supplied across Edmonton &amp; Alberta</p>
              </div>
            </div>
          </Reveal>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <SectionHeading
              chapter="01 / Who We Serve"
              overline="Trusted by Food Businesses"
              title={<>The first choice for Indian restaurants &amp; food businesses</>}
              lead="Brampton Cash & Carry understands the daily purchasing needs of busy commercial kitchens. We help restaurants reduce purchasing costs, simplify ordering and receive the supplies they need — without wasting time visiting multiple suppliers."
            />
            <motion.ul
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="flex flex-wrap gap-2.5 mt-8"
            >
              {BUSINESS_TYPES.map((t) => (
                <motion.li
                  key={t}
                  variants={fadeUp}
                  className="rounded-full border border-forest/25 bg-white px-4 py-2 text-sm font-medium text-forest hover:bg-butter hover:border-forest transition-colors duration-200"
                >
                  {t}
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  );
}
